import Card from "./card";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { useNavigate } from "react-router";
const GridSesions = ({ users }) => {
  const navigate = useNavigate();
  return (
    <div className="container-fluid mt-3">
    <div style={{margin:"0 auto"}}>
      <PerfectScrollbar className="px-3 w-100" style={{ height: "calc(100vh - 17rem)" }}>
       <div className="row row-cols-2 row-cols-md-5 row-cols-lg-5 row-cols-xl-4 row-cols-xxl-5 g-2">
        {users.map((user, index) => (
          <div key={index} className="col cursor-pointer" onClick={ () => navigate(`/live-metrics-sessions`)}>
            <Card {...user} />
          </div>
        ))}
      </div>
      </PerfectScrollbar>
      </div>
    </div>
  );
};
export default GridSesions;
